import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  width: 100%;
`;

const Label = styled.label`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.body2.fontSize};
  font-weight: 500;
`;

const StyledInput = styled.input`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.body1.fontSize};
  padding: 8px;
  // padding: ${props => props.size === 'small' ? '8px 12px' : props.size === 'large' ? '16px 20px' : '12px 16px'};
  border-radius: ${theme.borderRadius.md};
  border: 1px solid ${props => props.error ? theme.colors.error : 'rgba(0, 0, 0, 0.23)'};
   border-color: ${props => props.error ? theme.colors.error : theme.colors.primary};
  outline: none;
  transition: all 0.2s ease-in-out;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: ${props => props.error ? theme.colors.error : theme.colors.primary};
    box-shadow: 0 0 0 2px ${props => props.error ? `${theme.colors.error}20` : `${theme.colors.primary}20`};
  }

  &:hover {
    border-color: ${props => props.error ? theme.colors.error : 'rgba(0, 0, 0, 0.87)'};
  }

  &:disabled {
    background-color: rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 0, 0, 0.23);
    cursor: not-allowed;
  }

  &::placeholder {
    color: ${theme.colors.text.disabled};
  }
`;

const HelperText = styled.span`
  color: ${props => props.error ? theme.colors.error : theme.colors.text.secondary};
  font-size: ${theme.typography.body2.fontSize};
  margin-top: ${theme.spacing.xs};
`;

const Input = ({
  label,
  helperText,
  error,
  size = 'medium',
  className,
  ...props
}) => {
  return (
    <InputWrapper className={className}>
      {label && <Label>{label}</Label>}
      <StyledInput
        size={size}
        error={error}
        {...props}
      />
      {helperText && (
        <HelperText error={error}>
          {helperText}
        </HelperText>
      )}
    </InputWrapper>
  );
};

export default Input; 